/*
  assets/cozey-addons.js  (Liberator STORE)  —  moved out of snippets/cozey-addons.liquid on 2026-10-13 so it downloads
  once and is cached, instead of ~74 KB inline on every product page with add-on rows. Jaxx/Avana-only code removed
  (their quick view drawer, Shop Pay installments line, match_options, Avana form adapter); Liberator behaviour is unchanged.
  Loaded with <script defer> by snippets/cozey-addons.liquid. The rows are placed above the cuffs scroller / Add to cart
  by a tiny inline script in the snippet, so nothing shifts while this file loads.
*/
(function(){

  function norm(s){
    s = String(s == null ? '' : s).trim().toLowerCase();
    return s === 'colour' ? 'color' : s;
  }
  // "Sunbrella / Coral Sunbrella" -> "Coral Sunbrella": drop values repeated inside a later value.
  function variantLabel(v, fixed, singleOpts){
    var o = (v.options || []).filter(function(x, i){
      if(fixed && norm(x) === norm(fixed)) return false;
      return !(singleOpts && singleOpts.length > 0 && singleOpts.indexOf(i) !== -1 && v.options.length > 1);
    });
    return o.filter(function(x, i){
      return !o.slice(i + 1).some(function(y){ return norm(y).indexOf(norm(x)) !== -1; });
    }).join(' / ');
  }

  function boot(box){
    if(!box || box.getAttribute('data-cz-addons-init')) return;
    box.setAttribute('data-cz-addons-init', '1');

    // Liberator: move the rows into the product form, directly above the cuff scroller (or Add to cart), and
    // put them back if the theme's partial re-render (variant change) swaps that part of the page out.
    var czLib = box.getAttribute('data-cz-platform') === 'liberator';
    var czFormId = box.getAttribute('data-cz-form-id') || '';
    var czPlace = function(){
      var f = czFormId ? document.getElementById(czFormId) : null;
      if(!f) return;
      var cuff = f.querySelector('cuff-add-on');
      var target = cuff || f.querySelector('buy-buttons');
      if(!target || !target.parentNode) return;
      if(target.previousElementSibling === box) return;
      target.parentNode.insertBefore(box, target);
    };
    if(czLib){
      czPlace();
      new MutationObserver(function(){ if(!document.contains(box) || box.parentNode === null) czPlace(); else if(box.nextElementSibling && box.nextElementSibling.tagName !== 'CUFF-ADD-ON' && box.nextElementSibling.tagName !== 'BUY-BUTTONS') czPlace(); })
        .observe(document.body, { childList: true, subtree: true });
    }

    // Events and the 'cz-addons-on' class live on the section's <product-rerender>.
    var root = box.closest('product-rerender') || document.body;
    var errorEl = box.querySelector('[data-cz-addons-error]');

    var rows = [];
    box.querySelectorAll('[data-cz-addon-row]').forEach(function(el){
      var data;
      try { data = JSON.parse(el.querySelector('[data-cz-addon-data]').textContent); } catch(e){ return; }
      var r = {
        el: el, data: data, variants: data.variants || [],
        check: el.querySelector('[data-cz-addon-check]'),
        picker: el.querySelector('[data-cz-addon-picker]'),
        swatches: Array.prototype.slice.call(el.querySelectorAll('[data-cz-addon-val]')),
        optrows: Array.prototype.slice.call(el.querySelectorAll('.cz-addon__optrow')),
        main: el.querySelector('[data-cz-addon-main]'),
        img: el.querySelector('[data-cz-addon-img]'),
        price: el.querySelector('[data-cz-addon-price]'),
        sub: el.querySelector('[data-cz-addon-sub]'),
        chooseText: el.getAttribute('data-cz-addon-choose') || '',
        variant: null, on: false, hint: false,
        fixed: el.getAttribute('data-cz-addon-fixed') || '',
        when: el.getAttribute('data-cz-addon-when') || ''
      };
      r.single = !r.picker;
      // Options with one value across this row's variants (e.g. "Type: X-Wide" on a combined-listing member).
      r.singleOpts = (data.options || []).map(function(_, oi){
        var seen = {};
        r.variants.forEach(function(v){ seen[norm((v.options || [])[oi])] = 1; });
        return Object.keys(seen).length <= 1 ? oi : -1;
      }).filter(function(oi){ return oi !== -1; });
      r.defaultPrice = r.price ? r.price.innerHTML : '';
      r.defaultImg = r.img ? r.img.getAttribute('src') : '';
      r.defaultSub = r.sub ? r.sub.textContent : '';
      if(r.single) r.variant = r.variants[0] || null;
      rows.push(r);
    });
    if(!rows.length) return;

    // A swatch click on option oi: keep the other visible choices when that combination exists,
    // otherwise take the first in-stock variant carrying the clicked value.
    function variantFor(r, oi, val){
      var cur = r.variant, best = null;
      for(var i = 0; i < r.variants.length; i++){
        var v = r.variants[i];
        if(norm(v.options[oi]) !== norm(val)) continue;
        if(!best) best = v;
        if(!cur) break;
        var keep = r.swatches.every(function(b){
          var bi = parseInt(b.getAttribute('data-cz-addon-opt'), 10);
          return bi === oi || norm(v.options[bi]) === norm(cur.options[bi]);
        });
        if(keep) return v;
      }
      return best;
    }

    // Long rows: first N swatches + the selected one; "+N" counts the rest and reveals them.
    function applyTruncation(r){
      r.optrows.forEach(function(row){
        var more = row.querySelector('[data-cz-addon-more]');
        if(!more) return;
        var expanded = row.classList.contains('is-expanded');
        var hidden = 0;
        row.querySelectorAll('.cz-addon__sw.is-extra').forEach(function(b){
          var show = expanded || b.classList.contains('is-selected');
          b.classList.toggle('is-shown', show);
          if(!show) hidden++;
        });
        more.hidden = hidden === 0;
        more.textContent = '+' + hidden;
        more.setAttribute('aria-label', 'Show ' + hidden + ' more ' + (more.getAttribute('data-cz-addon-more-name') || '') + ' options');
      });
    }

    var czLibPending = !!czLib;
    // "You pay $X" (bundle price) for rows whose item has a bundle % (data.bp); same rounding as the cart.
    function czBp(r){ var n = parseFloat(r && r.data && r.data.bp); return n > 0 ? n : 0; }
    function czMoney(c){ var t = (c / 100).toFixed(2).split('.'); return '$' + t[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + t[1]; }
    function czPayHtml(r, v){
      var bp = czBp(r);
      if(!bp || !v || typeof v.cents !== 'number') return '';
      var off = Math.floor(v.cents * bp / 100 + 1e-6);   // the cart rounds the discount down to the cent
      return '<span class="cz-addon__pay">You pay ' + czMoney(v.cents - off) + '</span><s>' + v.price + '</s>';
    }
    // Sitewide sale price (2026-10-04) for rows WITHOUT a bundle price: the % comes from the same Kite rules the
    // product page and cards use (getKiteDiscountPercentForProductHandle in layout/theme.liquid), so it matches them
    // (e.g. 15% sitewide, 20% on chaises). Shown as "$X" with the regular price crossed out.
    var czQbRefresh = null;
    function czKiteHandle(r){ var m = String((r && r.data && r.data.url) || '').match(/\/products\/([^?#\/]+)/); return m ? m[1] : ''; }
    function czKitePct(r){ return (r && !czBp(r) && r.kitePct > 0) ? r.kitePct : 0; }
    function czSaleCents(c, p){ return Math.round(c * (100 - p) / 100); }
    function czSaleHtml(r, v){
      var p = czKitePct(r);
      if(!p || !v || typeof v.cents !== 'number') return '';
      return '<span class="cz-addon__pay">' + czMoney(czSaleCents(v.cents, p)) + '</span><s>' + v.price + '</s>';
    }
    function czSaleDefault(r){
      var p = czKitePct(r);
      if(!p) return '';
      var lo = null, hi = 0;
      r.variants.forEach(function(v){ if(typeof v.cents !== 'number') return; if(lo === null || v.cents < lo) lo = v.cents; if(v.cents > hi) hi = v.cents; });
      if(lo === null) return '';
      return '<span class="cz-addon__pay">' + (hi > lo ? 'from ' : '') + czMoney(czSaleCents(lo, p)) + '</span><s>' + czMoney(lo) + '</s>';
    }
    function czKiteLoad(){
      if(!czLib) return;
      var need = rows.filter(function(r){ return !czBp(r) && czKiteHandle(r); });
      if(!need.length) return;
      var tries = 0;
      (function wait(){
        var s = window.gfg && window.gfg.settings, k = window.kite_app_data && window.kite_app_data.settings;
        var ready = typeof window.getKiteDiscountPercentForProductHandle === 'function' &&
          !!((s && s.consolidatedCustomDiscount) || (k && k.consolidatedCustomDiscount));
        if(!ready){ if(++tries < 80) setTimeout(wait, 250); return; }
        need.forEach(function(r){
          Promise.resolve(window.getKiteDiscountPercentForProductHandle(czKiteHandle(r))).then(function(p){
            p = parseFloat(p);
            r.kitePct = p > 0 ? p : 0;
            if(r.kitePct){ render(r); if(czQbRefresh) czQbRefresh(r); }
          }, function(){});
        });
      })();
    }
    setTimeout(czKiteLoad, 0);
    function render(r){
      var v = r.variant;
      var on = !!(r.on && v);
      r.el.classList.toggle('is-on', on);
      r.el.classList.toggle('is-hinting', !!(r.hint && !v));
      // Liberator (2026-09-29): colour label + swatches stay hidden until the box is ticked (or a colour is set,
      // e.g. from the quick view); unticking collapses the row again.
      r.el.classList.toggle('is-open', !!(r.hint || r.on || v));
      r.el.classList.toggle('has-variant', !!v);
      r.check.checked = on || !!(czLibPending && r.hint && !v);
      r.swatches.forEach(function(b){
        var bi = parseInt(b.getAttribute('data-cz-addon-opt'), 10);
        var selected = !!(v && norm(v.options[bi]) === norm(b.getAttribute('data-cz-addon-val')));
        b.classList.toggle('is-selected', selected);
        b.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      applyTruncation(r);
      if(r.img){ var src = (v && v.img) || r.defaultImg; if(src && r.img.getAttribute('src') !== src) r.img.setAttribute('src', src); }
      if(r.price && !r.single){
        if(v){
          var html = czPayHtml(r, v) || czSaleHtml(r, v);
          if(!html){
            html = '<span>' + v.price + '</span>';
            if(v.compare) html += '<s>' + v.compare + '</s>';
          }
          r.price.innerHTML = html;
        } else {
          r.price.innerHTML = czSaleDefault(r) || r.defaultPrice;
        }
      } else if(r.price && r.single){
        var sh = czSaleHtml(r, r.variants[0]);
        if(sh && r.price.innerHTML !== sh) r.price.innerHTML = sh;
      }
      if(r.sub) r.sub.textContent = r.single ? r.defaultSub : (v ? variantLabel(v, r.fixed, r.singleOpts) : r.chooseText);
      r.el.setAttribute('data-cz-addon-on', on ? '1' : '0');
      r.el.setAttribute('data-cz-addon-variant', v ? String(v.id) : '');
    }
    function renderAll(){
      rows.forEach(render);
      root.classList.toggle('cz-addons-on', rows.some(function(r){ return r.on && r.variant; }));
    }
    function clearError(){ if(errorEl){ errorEl.textContent = ''; errorEl.classList.remove('is-visible'); } }
    // Switching a row off clears the colour it was holding, so an unticked row looks exactly like an untouched one.
    // Single-variant rows keep their only variant: there is nothing to pick and nothing highlighted.
    function rowOff(r){ r.on = false; r.hint = false; if(!r.single) r.variant = null; }

    rows.forEach(function(r){
      // The whole row is the click target for the checkbox, except its links, buttons and the swatch area.
      if(r.main){
        r.main.addEventListener('click', function(e){
          if(e.target && e.target.closest && e.target.closest('button, a, input, select, textarea, [data-cz-addon-picker]')) return;
          r.check.click();
        });
      }
      r.check.addEventListener('change', function(){
        clearError();
        if(r.check.checked && !r.variant){
          // Nothing picked yet: ask for a color. Liberator keeps the box ticked while the swatches are open
          // (the row only counts once a color is picked); elsewhere the box stays unticked.
          r.check.checked = !!czLibPending;
          r.hint = true;
          renderAll();
          var first = r.swatches[0];
          if(first) first.focus();
          return;
        }
        if(r.check.checked){ r.on = true; } else { rowOff(r); }
        renderAll();
      });
      r.swatches.forEach(function(b){
        b.addEventListener('click', function(){
          clearError();
          var v = variantFor(r, parseInt(b.getAttribute('data-cz-addon-opt'), 10), b.getAttribute('data-cz-addon-val'));
          if(!v) return;
          r.variant = v; r.on = true; r.hint = false;
          renderAll();
        });
      });
      r.el.querySelectorAll('[data-cz-addon-more]').forEach(function(more){
        more.addEventListener('click', function(){
          var row = more.closest('.cz-addon__optrow');
          var firstHidden = row.querySelector('.cz-addon__sw.is-extra:not(.is-shown)');
          row.classList.add('is-expanded');
          more.setAttribute('aria-expanded', 'true');
          applyTruncation(r);
          if(firstHidden) firstHidden.focus();
        });
      });
    });

    // ---------- Show when (rows tied to the page's selected option, e.g. Wedge Covers 24 in. -> Wedge) ----------
    (function(){
      var whenRows = rows.filter(function(r){ return r.when; });
      if(!whenRows.length) return;
      var mainData;
      try { mainData = JSON.parse(box.querySelector('[data-cz-main-variants]').textContent); } catch(e){ return; }
      var pageVariant = function(){
        var f = czFormId ? document.getElementById(czFormId) : null;
        var inp = (f && f.querySelector('input[name="id"]')) || document.querySelector('.cz-pdp__form input[name="id"], form[data-type="add-to-cart-form"] input[name="id"]');
        var id = inp && inp.value;
        if(!id) return null;
        for(var i = 0; i < mainData.variants.length; i++){ if(String(mainData.variants[i].id) === String(id)) return mainData.variants[i]; }
        return null;
      };
      var last = null;
      var sync = function(force){
        var pv = pageVariant();
        var key = pv ? String(pv.id) : '';
        if(!force && key === last) return;
        last = key;
        whenRows.forEach(function(r){
          var show = !!(pv && (pv.options || []).some(function(o){ return norm(o) === norm(r.when); }));
          if(r.el.hidden === !show) return;
          r.el.hidden = !show;
          if(!show) rowOff(r);
        });
        renderAll();
      };
      document.addEventListener('variant:change', function(){ setTimeout(function(){ sync(false); }, 0); });
      root.addEventListener('change', function(){ setTimeout(function(){ sync(false); }, 0); });
      root.addEventListener('click', function(){ setTimeout(function(){ sync(false); }, 50); });
      sync(true);
    })();

    // ---------- LIBERATOR ADAPTER (2026-09-28) ----------
    // Liberator (Stretch theme + Rebuy Smart Cart). snippets/cuff-add-on.liquid already takes over Add to cart
    // when cuffs are ticked; two take-overs on one form would block each other, so this one handles BOTH: the
    // main product, the ticked add-on rows and any ticked cuffs go in ONE /cart/add.js request, then the same
    // events the theme / cuff scroller fire are dispatched and Rebuy's cart is refreshed and opened.
    // Listened on WINDOW in the capture phase, which runs before cuff-add-on's own document-capture listener,
    // so cuff-add-on.liquid needs no change: when this handles the add, the event stops here.
    // Nothing ticked (rows or cuffs) = the theme's own add runs untouched (Rebuy add-ons included). When this handler
    // does the add, it hands off to any Rebuy product add-on widget with ticked items afterwards (see below).
    if(czLib && czFormId){
      var czLParent = box.getAttribute('data-cz-addon-parent') || '';
      var czLTitle = box.getAttribute('data-cz-addon-for') || '';
      var czCuffLines = function(form){
        var cuff = form.querySelector('cuff-add-on') || document.querySelector('cuff-add-on[data-form-id="' + czFormId + '"]');
        if(!cuff) return [];
        var parentTitle = cuff.getAttribute('data-parent-title') || czLTitle;
        var out = [];
        Array.prototype.slice.call(cuff.querySelectorAll('.cuff-add-on__checkbox')).forEach(function(cb){
          if(!cb.checked) return;
          var card = cb.closest('.cuff-add-on__card');
          var valEl = card ? card.querySelector('.cuff-add-on__qty-val') : null;
          var qty = valEl ? Math.max(1, parseInt(valEl.textContent, 10) || 1) : 1;
          out.push({ id: Number(cb.getAttribute('data-variant-id')), quantity: qty, properties: { '_cuff_addon': 'added', 'Add-on for': parentTitle } });
        });
        return out;
      };
      window.addEventListener('submit', function(event){
        var form = event.target;
        if(!form || form.tagName !== 'FORM' || form.getAttribute('id') !== czFormId) return;
        if(!document.contains(box)) return;
        // A row ticked without a color: don't add the main piece alone by surprise; ask for the color.
        var czPending = rows.filter(function(r){ return r.hint && !r.variant; });
        if(czPending.length){
          event.preventDefault(); event.stopImmediatePropagation();
          renderAll();
          czPending[0].el.scrollIntoView({ block: 'center', behavior: 'smooth' });
          var czFirst = czPending[0].swatches[0]; if(czFirst) czFirst.focus({ preventScroll: true });
          return;
        }
        var addons = [];
        rows.forEach(function(r){
          if(!(r.on && r.variant)) return;
          var q = parseInt(r.el.getAttribute('data-cz-addon-qty'), 10);
          var type = r.el.getAttribute('data-cz-addon-type') || '';
          var props = {};
          if(czLTitle) props._addon_for = czLTitle;
          if(czLParent) props._addon_parent = czLParent;
          if(type) props._addon_type = type;
          addons.push({ id: r.variant.id, quantity: q > 0 ? q : 1, properties: props });
        });
        var cuffs = czCuffLines(form);
        if(!addons.length && !cuffs.length) return;       // nothing extra: the theme adds normally

        event.preventDefault();
        event.stopImmediatePropagation();
        if(event.submitter && event.submitter.getAttribute('aria-busy') === 'true') return;
        if(!form.checkValidity()){ form.reportValidity(); return; }

        var fd = new FormData(form);
        var mainId = Number(fd.get('id'));
        if(!mainId) return;
        var main = { id: mainId, quantity: Number(fd.get('quantity') || 1), properties: {} };
        if(fd.get('selling_plan')) main.selling_plan = Number(fd.get('selling_plan'));
        fd.forEach(function(v, k){ var m = /^properties\[(.+)\]$/.exec(k); if(m) main.properties[m[1]] = v; });
        if(!Object.keys(main.properties).length) delete main.properties;
        var items = [main].concat(addons, cuffs);

        var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var settings = (window.themeVariables && window.themeVariables.settings) || {};
        var sectionsToBundle = new Set();
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
        var submitButtons = Array.prototype.slice.call(form.elements).filter(function(el){ return el.type === 'submit'; });
        document.querySelectorAll('button[type="submit"][form="' + czFormId + '"]').forEach(function(b){ if(submitButtons.indexOf(b) < 0) submitButtons.push(b); });
        var busy = function(on){
          submitButtons.forEach(function(b){ if(on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); });
          document.documentElement.dispatchEvent(new CustomEvent(on ? 'theme:loading:start' : 'theme:loading:end', { bubbles: true }));
        };
        busy(true);
        clearError();

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items, sections: Array.from(sectionsToBundle).join(',') })
        }).then(function(res){
          return res.json().then(function(json){ return { ok: res.ok, json: json }; });
        }).then(function(out){
          busy(false);
          if(!out.ok){
            var msg = (out.json && (out.json.description || out.json.message)) || '';
            root.dispatchEvent(new CustomEvent('cz:addons:error', { bubbles: true, detail: { message: msg } }));
            form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: msg } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            return;
          }
          if(settings.cartType === 'page' || settings.pageType === 'cart'){ window.location.href = rootUrl + 'cart'; return; }
          return fetch(rootUrl + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(cart){
            cart.sections = out.json.sections;
            var added = out.json.hasOwnProperty('items') ? out.json.items : [out.json];
            form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added, cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
            // Rebuy product add-on widgets (e.g. "Center Stage" on the Aria pages) add their ticked items from their
            // own submit handler, which never ran because this handler took the submit. Hand off to it now, so Rebuy
            // adds them its own way (with its own attribution). Guarded: skipped if Rebuy isn't there or nothing's ticked.
            var rebuyHandoff = null;
            try {
              var rw = (window.Rebuy && Rebuy.widgets) || {};
              Object.keys(rw).forEach(function(k){
                var w = rw[k];
                var picked = w && w.data && Array.isArray(w.data.products) && w.data.products.some(function(pp){ return pp && pp.selected; });
                if(picked && w.eventHandlers && typeof w.eventHandlers.formSubmit === 'function'){
                  var res = w.eventHandlers.formSubmit({});
                  if(res && typeof res.then === 'function') rebuyHandoff = (rebuyHandoff || Promise.resolve()).then(function(){ return res; });
                }
              });
            } catch(e){}
            // Rebuy Smart Cart: refresh its copy of the cart and open it (guarded; Rebuy may already have done both).
            try {
              if(window.Rebuy && Rebuy.Cart && typeof Rebuy.Cart.fetchCart === 'function') Rebuy.Cart.fetchCart();
              if(window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function') Rebuy.SmartCart.show();
            } catch(e){}
            root.dispatchEvent(new CustomEvent('cz:addons:added', { bubbles: true }));
          });
        }).catch(function(){
          busy(false);
          // Never block the sale: untick everything extra and fall back to the theme's own add.
          rows.forEach(function(r){ rowOff(r); });
          renderAll();
          var cuff = form.querySelector('cuff-add-on');
          if(cuff) cuff.querySelectorAll('.cuff-add-on__checkbox').forEach(function(cb){ cb.checked = false; });
          if(form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      }, true);
    }


    // ---------- LIBERATOR QUICK VIEW (2026-09-28) ----------
    // The theme's own quick buy (<quick-buy-modal>, theme.js QuickBuyModal): it fetches the add-on's product page and
    // shows that page's #quick-buy-content (gallery, title, price, the theme's variant picker, buy buttons). This widget
    // opens its OWN instance (#cz-lib-quickbuy), so product-card quick buys elsewhere keep adding to the cart as usual.
    // In this instance only: the fixed size option (variant_filter) is hidden, quantity / Shop Pay are hidden, the
    // button reads "Add to my order" / "Update my order" and ticks the row with the picked variant (it never adds to the
    // cart itself), Kite's sitewide price is hidden (the add-on price is the full price) and, on desktop, the product
    // title + subtitle and the plain price are added (the theme's own "View details" links to the page).
    if(czLib && window.customElements && window.customElements.get('quick-buy-modal')){
      var czQb = null, czQbRow = null;
      var czQbLabel = function(){ return (czQbRow && czQbRow.on && czQbRow.variant) ? 'Update my order' : 'Add to my order'; };
      var czQbForm = function(){ return czQb ? czQb.querySelector('form[action*="/cart/add"]') : null; };
      var czQbTidy = function(){
        if(!czQb || !czQbRow) return;
        var form = czQbForm();
        // Hide the option that variant_filter fixes (e.g. "Type: 24 in.") so only the colour is picked here.
        if(czQbRow.fixed){
          czQb.querySelectorAll('.variant-picker__option').forEach(function(fs){
            var vals = Array.prototype.slice.call(fs.querySelectorAll('input')).map(function(i){
              var l = (i.id && czQb.querySelector('label[for="' + i.id + '"]')) || i.closest('label') || i.parentNode;
              return norm((l && l.textContent) || i.value);
            });
            if(vals.some(function(v){ return v === norm(czQbRow.fixed); })){
              fs.style.display = 'none';
              // Show the fixed size as plain text where its picker was, styled like the theme's "Color:" line.
              if(!fs.parentNode.querySelector('[data-cz-qb-fixed]')){
                var fx = document.createElement('p');
                fx.className = 'cz-qb-fixed';
                fx.setAttribute('data-cz-qb-fixed', '');
                var lg = document.createElement('span'); lg.className = 'text-subdued'; lg.textContent = 'Size:';
                var vl = document.createElement('span'); vl.textContent = czQbRow.fixed;
                fx.appendChild(lg); fx.appendChild(document.createTextNode(' ')); fx.appendChild(vl);
                fs.parentNode.insertBefore(fx, fs.nextSibling);
              }
            }
          });
        }
        // Combined-listing pickers (e.g. the Wedge's "Type: Original / X-Wide / Bondage") are not options of this
        // product; choosing one would switch to another product this row can't add, so they're hidden here.
        // Same for an option with only one value on this product (the Wedge (X-Wide)'s "Type: X-Wide").
        var ownOpts = (czQbRow.data.options || []).map(norm);
        czQb.querySelectorAll('.variant-picker__option').forEach(function(fs){
          var lg = fs.querySelector('legend');
          var nm = lg ? norm(lg.textContent.replace(':', '')) : '';
          if(!nm) return;
          var oi = ownOpts.indexOf(nm);
          if(oi === -1 || czQbRow.singleOpts.indexOf(oi) !== -1) fs.style.display = 'none';
        });
        // Relabel the submit button(s), keeping the theme's button markup.
        czQb.querySelectorAll('buy-buttons button[type="submit"], button[type="submit"][name="add"]').forEach(function(b){
          b.querySelectorAll('[up-text]').forEach(function(c){ if(c.getAttribute('up-text') !== czQbLabel()) c.setAttribute('up-text', czQbLabel()); });
          var w = document.createTreeWalker(b, NodeFilter.SHOW_TEXT), n, done = false;
          while((n = w.nextNode())){
            if(!n.nodeValue.trim()) continue;
            if(!done){ if(n.nodeValue.trim() !== czQbLabel()) n.nodeValue = czQbLabel(); done = true; }
            else if(n.nodeValue.trim()) n.nodeValue = '';
          }
        });
        // Desktop: this template's title is a custom Liquid block the quick buy doesn't carry, and Kite's price block
        // shows the sitewide price (the add-on price is the full price). Add the product-page title + subtitle and the
        // plain variant price under the vendor badge. md-max:hidden = desktop only; below md the theme's own quick buy
        // header already shows the title and the regular price.
        var id = form && form.querySelector('input[name="id"]') ? form.querySelector('input[name="id"]').value : '';
        var cur = null;
        for(var k = 0; k < czQbRow.variants.length; k++){ if(String(czQbRow.variants[k].id) === String(id)){ cur = czQbRow.variants[k]; break; } }
        var head = czQb.querySelector('[data-cz-qb-head]');
        if(!head){
          var vendor = czQb.querySelector('.quick-buy__info .vendor');
          var item = vendor ? vendor.closest('.product-info__block-item') : null;
          if(item && item.parentNode){
            head = document.createElement('div');
            head.className = 'product-info__block-item cz-qb-head md-max:hidden';
            head.setAttribute('data-cz-qb-head', '');
            var h = document.createElement('h2'); h.className = 'cz-qb-title';
            var nm = document.createElement('span'); nm.className = 'cz-qb-name'; nm.textContent = czQbRow.data.title || ''; h.appendChild(nm);
            if(czQbRow.data.h1){ var eb = document.createElement('span'); eb.className = 'cz-qb-eyebrow'; eb.textContent = czQbRow.data.h1; h.appendChild(eb); }
            var pr = document.createElement('p'); pr.className = 'cz-qb-price'; pr.setAttribute('data-cz-qb-price', '');
            head.appendChild(h); head.appendChild(pr);
            if(czQbRow.data.save){ var sv = document.createElement('p'); sv.className = 'cz-qb-save'; sv.textContent = czQbRow.data.save; head.appendChild(sv); }
            item.parentNode.insertBefore(head, item.nextSibling);
          }
        }
        // Mobile header (theme markup): the pairing's savings message takes the "+ extra 10%" line's place.
        if(czQbRow.data.save && !czQb.querySelector('[data-cz-qb-save-m]')){
          var mpl = czQb.querySelector('.quick-buy > .v-stack > .h-stack price-list');
          if(mpl && mpl.parentNode){
            var msv = document.createElement('p');
            msv.className = 'cz-qb-save';
            msv.setAttribute('data-cz-qb-save-m', '');
            msv.textContent = czQbRow.data.save;
            mpl.parentNode.insertBefore(msv, mpl.nextSibling);
          }
        }
        // "View details" goes directly under the button (above the divider), not at the very bottom.
        var det = czQb.querySelector('.product-info__block-list > a.link, [data-cz-qb-details]');
        var pfItem = czQb.querySelector('.quick-buy__info product-form');
        pfItem = pfItem ? pfItem.closest('.product-info__block-item') : null;
        if(det && pfItem){
          det.setAttribute('data-cz-qb-details', '');
          var dh = czQbRow.data.url + (id ? '?variant=' + id : '');
          if(det.getAttribute('href') !== dh) det.setAttribute('href', dh);
          if(det.parentNode !== pfItem) pfItem.appendChild(det);
        }
        var priceEl = head ? head.querySelector('[data-cz-qb-price]') : null;
        var priceTxt = cur ? cur.price : (czQbRow.variants[0] ? czQbRow.variants[0].price : '');
        var payHtml = czPayHtml(czQbRow, cur || czQbRow.variants[0]);
        // No bundle price: the sitewide sale price instead (2026-10-04), plus the product page's "+ extra 10%..." line.
        var saleHtml = payHtml ? '' : czSaleHtml(czQbRow, cur || czQbRow.variants[0]);
        var lineHtml = payHtml || saleHtml;
        if(priceEl){
          if(lineHtml){ if(priceEl.innerHTML !== lineHtml) priceEl.innerHTML = lineHtml; }
          else if(priceEl.textContent !== priceTxt) priceEl.textContent = priceTxt;
        }
        var acSrc = czQb.querySelector('.product-after-code');
        var acHtml = (saleHtml && acSrc) ? acSrc.innerHTML : '';
        var putAfter = function(el, anchor){ if(el && anchor && el.previousElementSibling !== anchor) anchor.parentNode.insertBefore(el, anchor.nextSibling); };
        var mkLine = function(cls, attr){ var e = document.createElement('p'); e.className = cls; e.setAttribute(attr, ''); return e; };
        // Desktop header: the "+ extra 10%" line right under the price.
        var dAc = czQb.querySelector('[data-cz-qb-after]');
        if(acHtml && priceEl){
          if(!dAc) dAc = mkLine('cz-qb-after', 'data-cz-qb-after');
          putAfter(dAc, priceEl);
          if(dAc.innerHTML !== acHtml) dAc.innerHTML = acHtml;
        } else if(dAc){ dAc.remove(); }
        // Mobile header: bundle price -> "You pay" line under the savings message (as before); sale price -> our own
        // price line in place of the theme's regular price, then the "+ extra 10%" line, then the savings message.
        var mpl = czQb.querySelector('.quick-buy > .v-stack > .h-stack price-list');
        var mSave = czQb.querySelector('[data-cz-qb-save-m]');
        var mPay = czQb.querySelector('[data-cz-qb-pay-m]');
        var own = !payHtml && !!saleHtml;
        if(czQb.classList.contains('cz-qb-own-price') !== own) czQb.classList.toggle('cz-qb-own-price', own);
        if(lineHtml){
          var anchor = payHtml ? (mSave || mpl) : mpl;
          if(!mPay && anchor) mPay = mkLine('cz-qb-pay-m', 'data-cz-qb-pay-m');
          putAfter(mPay, anchor);
          if(mPay && mPay.innerHTML !== lineHtml) mPay.innerHTML = lineHtml;
        } else if(mPay){ mPay.remove(); mPay = null; }
        var mAc = czQb.querySelector('[data-cz-qb-after-m]');
        if(acHtml && own && mPay){
          if(!mAc) mAc = mkLine('cz-qb-after', 'data-cz-qb-after-m');
          putAfter(mAc, mPay);
          if(mAc.innerHTML !== acHtml) mAc.innerHTML = acHtml;
        } else if(mAc){ mAc.remove(); }
      };
      czQbRefresh = function(r){ if(czQb && czQbRow === r && czQb.hasAttribute('open')) czQbTidy(); };
      // iPhone Safari (iOS 26) floating toolbar (2026-10-04): fixed layers (the quick view and its blurred backdrop)
      // stop at the top of the toolbar, and Safari draws the PAGE under the toolbar, so the page showed through below
      // the sheet. CSS on the fixed layers can't reach that strip, so while the quick view is open a plain block in the
      // page itself (absolute, not fixed) sits just below the visible area, in the sheet's colour. Off-screen and
      // harmless on every other browser.
      // Timing (v6): the theme sets "open" first, then loads the product, and only then animates the sheet in. So the block
      // follows the theme's own animation events instead of "open": it fades in on dialog:before-show using the same
      // timing as the sheet (starts 0.1s in, 0.25s long), and fades out with the sheet on close (0.15s), then is removed.
      // Repositioning is batched to one update per frame.
      var czFillEl = null, czFillOn = false, czFillRaf = 0, czFillGen = 0;
      var czFillPlace = function(){
        if(!czFillOn || !czFillEl) return;
        var vv = window.visualViewport;
        var top = window.scrollY + Math.min(window.innerHeight, vv ? vv.height + vv.offsetTop : window.innerHeight) - 160;   // starts hidden behind the sheet
        czFillEl.style.top = top + 'px';
      };
      var czFillQueue = function(){
        if(czFillRaf) return;
        czFillRaf = requestAnimationFrame(function(){ czFillRaf = 0; czFillPlace(); });
      };
      var czFillListen = function(on){
        var f = on ? 'addEventListener' : 'removeEventListener';
        window[f]('scroll', czFillQueue, { passive: true });
        window[f]('resize', czFillQueue);
        if(window.visualViewport) window.visualViewport[f]('resize', czFillQueue);
      };
      // 'enter' = sheet is about to animate in, 'shown' = animation finished, 'leave' = closing, 'gone' = closed.
      var czQbFill = function(state){
        if(state === 'enter' || state === 'shown'){
          if(!czFillEl){
            czFillEl = document.createElement('div');
            czFillEl.setAttribute('aria-hidden', 'true');
            czFillEl.style.cssText = 'position:absolute;left:0;right:0;height:560px;z-index:998;pointer-events:none;background:#fff;opacity:0';
          }
          if(!czFillOn){
            czFillOn = true; czFillGen++;
            try { var bg = getComputedStyle(czQb).getPropertyValue('--background').trim(); if(bg) czFillEl.style.background = 'rgb(' + bg + ')'; } catch(e){}
            if(czFillEl.parentNode !== document.body) document.body.appendChild(czFillEl);
            czFillListen(true);
          }
          czFillPlace();
          if(state === 'enter'){
            czFillEl.style.transition = 'none'; czFillEl.style.opacity = '0';
            void czFillEl.offsetWidth;
            czFillEl.style.transition = 'opacity .25s ease .1s';
          }
          czFillEl.style.opacity = '1';
        } else if(state === 'leave'){
          if(!czFillOn || !czFillEl) return;
          czFillEl.style.transition = 'opacity .15s ease';
          czFillEl.style.opacity = '0';
        } else if(state === 'gone'){
          if(!czFillOn) return;
          czFillOn = false; czFillGen++;
          czFillListen(false);
          if(czFillRaf){ cancelAnimationFrame(czFillRaf); czFillRaf = 0; }
          if(czFillEl && czFillEl.parentNode) czFillEl.parentNode.removeChild(czFillEl);
        }
      };
      var czQbEnsure = function(){
        if(czQb && document.contains(czQb) && typeof czQb.show === 'function') return czQb;
        // Built from markup (like the theme's own Liquid does): the element's constructor sets attributes, which
        // document.createElement() does not allow for custom elements.
        var holder = document.createElement('div');
        holder.innerHTML = '<quick-buy-modal id="cz-lib-quickbuy" class="modal modal--quick-buy color-scheme color-scheme--' +
          String(box.getAttribute('data-cz-qb-scheme') || '').replace(/[^\w-]/g, '') + '"></quick-buy-modal>';
        czQb = holder.firstElementChild;
        document.body.appendChild(czQb);
        // While this quick view is open, the floating chat (Shopify Inbox) and Attentive bubbles are hidden so they
        // don't cover its colours / button; they come back as soon as it closes.
        new MutationObserver(function(){
          document.documentElement.classList.toggle('cz-qb-open', czQb.hasAttribute('open'));
          if(!czQb.hasAttribute('open')) czQbFill('leave');
        }).observe(czQb, { attributes: true, attributeFilter: ['open'] });
        // iPhone bottom block follows the sheet's own animation (see czQbFill).
        czQb.addEventListener('dialog:before-show', function(){ czQbFill('enter'); });
        czQb.addEventListener('dialog:after-show', function(){ if(czQb.hasAttribute('open')) czQbFill('shown'); });
        czQb.addEventListener('dialog:after-hide', function(){ if(!czQb.hasAttribute('open')) czQbFill('gone'); });
        // The theme re-renders parts of the quick buy on every variant change: re-apply our changes each time.
        var pending = false;
        new MutationObserver(function(){
          if(pending) return; pending = true;
          requestAnimationFrame(function(){ pending = false; czQbTidy(); });
        }).observe(czQb, { childList: true, subtree: true });
        return czQb;
      };
      var czQbOpen = function(r){
        czQbRow = r;
        var m = czQbEnsure();
        var start = r.variant || r.variants[0];
        m.setAttribute('product-url', r.data.url + (start ? '?variant=' + start.id : ''));
        var shown = m.show();
        if(shown && shown.then) shown.then(czQbTidy);
      };
      rows.forEach(function(r){
        var a = r.el.querySelector('[data-cz-lib-qv]');
        if(!a) return;
        a.addEventListener('click', function(e){
          if(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;   // new-tab clicks open the page
          e.preventDefault();
          e.stopPropagation();
          czQbOpen(r);
        });
      });
      // Its button ticks the row instead of adding to the cart. Window capture phase: runs before the theme's handlers.
      window.addEventListener('submit', function(event){
        var form = event.target;
        if(!czQb || !czQbRow || !form || !czQb.contains(form)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var id = String(new FormData(form).get('id') || '');
        var hit = null;
        for(var i = 0; i < czQbRow.variants.length; i++){ if(String(czQbRow.variants[i].id) === id){ hit = czQbRow.variants[i]; break; } }
        var note = czQb.querySelector('[data-cz-qb-note]');
        if(!hit){
          if(!note){
            note = document.createElement('p');
            note.className = 'cz-qb-note';
            note.setAttribute('data-cz-qb-note', '');
            var pf = czQb.querySelector('.quick-buy__info product-form');
            if(pf && pf.parentNode) pf.parentNode.insertBefore(note, pf.nextSibling);
          }
          note.textContent = 'That option can\'t be added here. Please pick another color.';
          return;
        }
        czQbRow.variant = hit; czQbRow.on = true; czQbRow.hint = false;
        clearError();
        renderAll();
        if(typeof czQb.hide === 'function') czQb.hide();
      }, true);
    }

    // Fired by the Liberator adapter above after the cart request: reset every row.
    root.addEventListener('cz:addons:added', function(){
      rows.forEach(function(r){ rowOff(r); });
      clearError();
      renderAll();
    });
    root.addEventListener('cz:addons:error', function(e){
      if(!errorEl) return;
      errorEl.textContent = (e.detail && e.detail.message) || 'We couldn\'t add these items to your cart. Please try again.';
      errorEl.classList.add('is-visible');
    });

    renderAll();
  }

  // Loaded with defer by snippets/cozey-addons.liquid (was inline until 2026-10-13). Boots at DOMContentLoaded,
  // same as the old inline copy, so theme.js / Rebuy / Kite are ready; 'load' is only a backstop.
  function bootAll(){ document.querySelectorAll('[data-cz-addons]').forEach(boot); }
  if(document.readyState === 'complete'){ setTimeout(bootAll, 0); }
  else {
    document.addEventListener('DOMContentLoaded', bootAll);
    window.addEventListener('load', bootAll);
  }
})();
